import { render, staticRenderFns } from "./AddRadish.vue?vue&type=template&id=2a1b84b2&scoped=true"
import script from "./AddRadish.vue?vue&type=script&lang=js"
export * from "./AddRadish.vue?vue&type=script&lang=js"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=2a1b84b2&prod&scoped=true&lang=css&external"
import style1 from "./AddRadish.vue?vue&type=style&index=1&id=2a1b84b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b84b2",
  null
  
)

export default component.exports